<template>
  <div>
    <form novalidate @submit.prevent="salvar()">
      <slot name="form" />
      <ToolbarCadastro
        :voltar="voltar"
        :tem-voltar="temVoltar"
        :pode-salvar="podeSalvar"
      >
        <slot name="toolbar" />
      </ToolbarCadastro>
    </form>
  </div>
</template>

<script>
import ToolbarCadastro from '@/componentes/ToolbarCadastro'

export default {
  name: 'BlocoFormularioCadastro',
  components: { ToolbarCadastro },
  props: {
    temVoltar: {
      type: Boolean,
      default: true,
    },
    voltar: {
      type: String,
      required: true,
      default: '/',
    },
    podeSalvar: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    salvar() {
      this.$emit('salvar')
    },
  },
}
</script>
